const ROUTER_LIST_KEY = 'charge_router_list'
const LAST_AUTH_ROUTE_KEY = 'charge_last_auth_route'

const ROUTE_FIELD_KEYS = [
  'path',
  'menuPath',
  'routePath',
  'routerPath',
  'menuRoute',
  'url'
]

const CHILD_FIELD_KEYS = [
  'children',
  'childList',
  'menus',
  'menuList',
  'routerList',
  'routes'
]

export const normalizeRoutePath = (path) => {
  if (!path || typeof path !== 'string') return ''
  const cleanPath = path.trim().split('?')[0].split('#')[0]
  if (!cleanPath) return ''
  const routePath = cleanPath.startsWith('/') ? cleanPath : `/${cleanPath}`
  return routePath.length > 1 ? routePath.replace(/\/+$/, '') : routePath
}

const collectRoutePaths = (list, paths) => {
  if (!Array.isArray(list)) return
  list.forEach(item => {
    if (typeof item === 'string') {
      const routePath = normalizeRoutePath(item)
      if (routePath) paths.add(routePath)
      return
    }
    if (!item || typeof item !== 'object') return

    ROUTE_FIELD_KEYS.forEach(key => {
      const routePath = normalizeRoutePath(item[key])
      if (routePath) paths.add(routePath)
    })
    CHILD_FIELD_KEYS.forEach(key => collectRoutePaths(item[key], paths))
  })
}

export const getAllowedRoutePaths = (routerList = getRouterList()) => {
  const paths = new Set()
  collectRoutePaths(routerList, paths)
  return paths
}

export const saveRouterList = (routerList) => {
  const list = Array.isArray(routerList) ? routerList : []
  localStorage.setItem(ROUTER_LIST_KEY, JSON.stringify(list))
}

export const getRouterList = () => {
  try {
    const raw = localStorage.getItem(ROUTER_LIST_KEY)
    return raw ? JSON.parse(raw) : []
  } catch (e) {
    return []
  }
}

export const removeRouterList = () => {
  localStorage.removeItem(ROUTER_LIST_KEY)
  sessionStorage.removeItem(LAST_AUTH_ROUTE_KEY)
}

const isPathAllowed = (path, allowedPaths) => {
  const routePath = normalizeRoutePath(path)
  if (!routePath) return false
  return allowedPaths.has(routePath)
}

export const hasRoutePermission = (route) => {
  const allowedPaths = getAllowedRoutePaths()
  if (!allowedPaths.size) return false

  const routePath = normalizeRoutePath(route.path)
  const activeMenu = normalizeRoutePath(route.meta && route.meta.activeMenu)
  const menuGroup = normalizeRoutePath(route.meta && route.meta.menu)
  return isPathAllowed(activeMenu || routePath, allowedPaths) ||
    isPathAllowed(routePath, allowedPaths) ||
    (!!menuGroup && isPathAllowed(menuGroup, allowedPaths))
}

export const filterAuthorizedRoutes = (routes, routerList) => {
  // routerList 有值时用传入的（响应式场景），否则从 localStorage 读（路由守卫场景）
  const allowedPaths = (routerList && routerList.length)
    ? getAllowedRoutePaths(routerList)
    : getAllowedRoutePaths()
  if (!allowedPaths.size) return []
  return routes.filter(route => isPathAllowed(route.path, allowedPaths))
}

export const getFirstAuthorizedPath = (routes) => {
  const firstRoute = filterAuthorizedRoutes(routes)[0]
  return firstRoute ? firstRoute.path : '/403'
}

export const saveLastAuthorizedRoute = (path) => {
  const routePath = normalizeRoutePath(path)
  if (routePath) sessionStorage.setItem(LAST_AUTH_ROUTE_KEY, routePath)
}

export const getLastAuthorizedRoute = () => {
  return normalizeRoutePath(sessionStorage.getItem(LAST_AUTH_ROUTE_KEY))
}
